import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';

import { SnSelectFormField } from './components/form-field/select.form-field';

@NgModule({
  exports: [MatSelectModule, SnButtonModule],
  declarations: [SnSelectFormField],
  imports: [
    // Angular
    CommonModule,
    ReactiveFormsModule,
    // Material
    MatSelectModule,
    MatProgressBarModule,
    MatPseudoCheckboxModule,
    MatTooltipModule,
    SnButtonModule,
    // Formly
    FormlySelectModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'select',
          component: SnSelectFormField,
          wrappers: ['form-field'],
        },
      ],
    }),
    SnIconModule,
  ],
})
export class SnFormSelectModule {}
